import { t } from 'i18next';
import { z } from 'zod';

export const DashboardPageFilterFormSchema = z.object({  
  startDate: z
    .date({ message: t('elements.form.startDate.error') })
    .nullable()
    .optional(),
  endDate: z
    .date()
    .nullable()
    .optional(),
  apartmentId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    }))
    .optional(),  
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: t('elements.form.datesDifference.error'),
    path: ['endDate'],
  },
);